import React from "react";
import { Link } from "react-router-dom";

const Button = (props) => {
  return (
    <Link to={props.link} className="button">
      <div className="button__line"></div>
      <div className="button__line"></div>
      <span className="button__text">{props.text}</span>
      <div className="button__drow1"></div>
      <div className="button__drow2"></div>
    </Link>
  );
};

export default Button;
